import { setDoc, doc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/config";

const ACCESS_COLLECTION = "private";
const ACCESS_DOC_ID = "access";

function isPermissionDenied(err) {
  const code = err?.code || "";
  return code === "permission-denied" || code === "PERMISSION_DENIED";
}

/**
 * Atomically create public match doc + private access credentials.
 * Two commits (not one batch): access rules read the parent match via get(),
 * which is unreliable in the same batch as the parent create.
 */
export async function batchCreateMatchWithAccess(matchId, matchPayload, accessPayload) {
  const matchRef = doc(db, "matches", matchId);
  const accessRef = doc(db, "matches", matchId, ACCESS_COLLECTION, ACCESS_DOC_ID);
  await setDoc(matchRef, matchPayload);
  await setDoc(accessRef, {
    refCode: accessPayload.refCode || "",
    viewCode: accessPayload.viewCode || "",
    updatedAt: serverTimestamp(),
  });
}

export { isPermissionDenied };
